// extracted by mini-css-extract-plugin
module.exports = {"loader":"error_loader__uP8wX","animated-logo":"error_animated-logo__7OUfP","pulse":"error_pulse__Tosv2","status":"error_status__UYICn"};